/**
 * Script para corrigir posicionamento do botão no menu de conta
 * Move botão problemático para dentro do menu lateral na seção de fidelidade
 */
(function() {
  'use strict';
  
  function moveButtonToSidebar() {
    // Verificar se estamos em uma página de conta/login
    const isAccountPage = window.location.pathname.includes('/account') || 
                         document.querySelector('.customer.account, .customer.login');
    
    if (!isAccountPage) return;
    
    // Encontrar o botão problemático
    let problemButton = null;
    
    // Estratégia 1: Procurar por imagem "botao.png" ou similar
    const images = document.querySelectorAll('img');
    for (const img of images) {
      const src = (img.src || '').toLowerCase();
      const alt = ((img.alt || '') + ' ' + (img.title || '')).toLowerCase();
      
      if (src.includes('botao') || alt.includes('botao') || 
          src.includes('aproveite') || alt.includes('aproveite')) {
        const rect = img.getBoundingClientRect();
        const isInMainContent = rect.left > 350;
        const isInSidebar = img.closest('[class*="sidebar"], [class*="menu"], aside, [class*="fidelidade"]');
        
        if (isInMainContent && !isInSidebar) {
          problemButton = img;
          break;
        }
      }
    }
    
    // Estratégia 2: Procurar por botão com texto "APROVEITE"
    if (!problemButton) {
      const buttons = document.querySelectorAll('button, a[role="button"], .button');
      for (const btn of buttons) {
        const text = (btn.textContent || '').trim().toUpperCase();
        if (text.includes('APROVEITE') || text.includes('OFERTAS')) {
          const rect = btn.getBoundingClientRect();
          const isInMainContent = rect.left > 350;
          const isInSidebar = btn.closest('[class*="sidebar"], [class*="menu"], aside');
          
          if (isInMainContent && !isInSidebar) {
            problemButton = btn;
            break;
          }
        }
      }
    }
    
    if (!problemButton) return;
    
    // Encontrar o menu lateral
    let sidebar = null;
    
    // Procurar por elementos que contenham texto do menu
    const allDivs = document.querySelectorAll('div');
    for (const div of allDivs) {
      const text = div.textContent || '';
      if (text.includes('Bem-vindo') || text.includes('Visto recentemente') || text.includes('Salvo do seu carrinho')) {
        const rect = div.getBoundingClientRect();
        if (rect.left < 400 && rect.width < 500) {
          sidebar = div.closest('div, aside, section') || div;
          break;
        }
      }
    }
    
    // Se não encontrou, procurar por estrutura do app
    if (!sidebar) {
      const appContainers = document.querySelectorAll('[id*="fidelizarmais"], [class*="fidelizarmais"], [data-widget]');
      if (appContainers.length > 0) {
        for (const container of appContainers) {
          let parent = container.closest('div, aside, section');
          if (parent) {
            const rect = parent.getBoundingClientRect();
            if (rect.left < 400) {
              sidebar = parent;
              break;
            }
          }
        }
      }
    }
    
    if (!sidebar) return;
    
    // Encontrar ou criar seção de fidelidade
    let fidelidadeSection = sidebar.querySelector('[class*="fidelidade"], [id*="fidelidade"]');
    
    if (!fidelidadeSection) {
      const allElements = sidebar.querySelectorAll('*');
      for (const el of allElements) {
        const text = (el.textContent || '').toLowerCase();
        if (text.includes('fidelidade') || text.includes('programa') || text.includes('pontos')) {
          fidelidadeSection = el.closest('div, section, li, ul');
          if (fidelidadeSection && fidelidadeSection !== sidebar) {
            break;
          }
        }
      }
    }
    
    // Se não encontrou, criar após "Salvo do seu carrinho"
    if (!fidelidadeSection) {
      const allElements = sidebar.querySelectorAll('*');
      let insertAfterElement = null;
      
      for (const el of allElements) {
        const text = (el.textContent || '').toLowerCase();
        if (text.includes('salvo do seu carrinho') || text.includes('saved from your cart')) {
          insertAfterElement = el.closest('div, section, li');
          break;
        }
      }
      
      if (!insertAfterElement) {
        for (const el of allElements) {
          const text = (el.textContent || '').toLowerCase();
          if (text.includes('visto recentemente') || text.includes('recently viewed')) {
            insertAfterElement = el.closest('div, section, li');
            break;
          }
        }
      }
      
      fidelidadeSection = document.createElement('div');
      fidelidadeSection.className = 'fidelidade-menu-section';
      fidelidadeSection.style.cssText = 'margin-top: 2rem; padding: 1.5rem 0; border-top: 1px solid rgba(var(--color-foreground), 0.1);';
      
      if (insertAfterElement && insertAfterElement.parentElement) {
        insertAfterElement.parentElement.insertBefore(fidelidadeSection, insertAfterElement.nextSibling);
      } else {
        sidebar.appendChild(fidelidadeSection);
      }
    }
    
    // Mover o botão
    if (fidelidadeSection) {
      const buttonClone = problemButton.cloneNode(true);
      
      if (buttonClone.tagName === 'IMG') {
        const container = document.createElement('div');
        container.className = 'fidelidade-button-container';
        container.style.cssText = 'margin-top: 1rem;';
        
        const link = document.createElement('a');
        link.href = buttonClone.src || '#';
        link.appendChild(buttonClone);
        link.style.cssText = 'display: block; width: 100%;';
        buttonClone.style.cssText = 'max-width: 100%; height: auto; display: block;';
        
        container.appendChild(link);
        fidelidadeSection.appendChild(container);
      } else {
        buttonClone.style.cssText = 'width: 100%; padding: 1rem; margin-top: 1rem; text-align: center; background-color: rgb(var(--color-button)); color: rgb(var(--color-button-text)); border: none; border-radius: 0; cursor: pointer; font-size: 1.4rem;';
        fidelidadeSection.appendChild(buttonClone);
      }
      
      problemButton.style.display = 'none';
      problemButton.remove();
    }
  }
  
  // Executar quando DOM estiver pronto
  function init() {
    setTimeout(moveButtonToSidebar, 1000);
    setTimeout(moveButtonToSidebar, 3000);
    setTimeout(moveButtonToSidebar, 5000);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Observar mudanças no DOM
  const observer = new MutationObserver(function() {
    setTimeout(moveButtonToSidebar, 500);
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

